import {Image} from '@volkswagen-onehub/components-core';
import * as React from 'react';
import Div from '../components/Div.styled';
import DescriptionPage from '../components/HeadlineSubHeadlineText';
import useMediaQuery from '../hooks/useMediaQuery';
import {JSONMARKDOWN, VWCARMODELLABELS} from '../types/results';
import {VWCarModel} from '../types/surveyResponse';
import {AnalyticEvent, sendAnalyticPayload} from '../utils/analytic';
import {getMoreAboutEvRangeLink} from '../utils/carUtils';

interface IBannerProps {
  model: VWCarModel;
  assetUrl: string;
  image: string;
  hero_sub_title: string;
  hero_title_line_1: string;
  hero_title_line_2: string;
  body: string;
}

const getCTAButtonTitle = (
  model: VWCarModel | undefined,
  isTwoCars: boolean,
) => {
  if (!model) return '';
  if (isTwoCars) {
    return `Discover the EV Range`;
  }
  return `Discover the ${VWCARMODELLABELS[model]}`;
};

export default function ResultSectionFour({
  model,
  assetUrl,
  image,
  hero_sub_title,
  hero_title_line_1,
  hero_title_line_2,
  body,
}: IBannerProps) {
  const {isDesktop} = useMediaQuery();
  const isTwoCars = model === 'id4Andid5' || model === 'id4gtxAndid5gtx';
  const CTAButtonTitle = getCTAButtonTitle(model, isTwoCars);

  function onClickHandleCTA(
    model: VWCarModel | undefined,
    CTAButtonTitle: string,
  ) {
    window.open(getMoreAboutEvRangeLink(model as VWCarModel));
    sendAnalyticPayload(
      {
        process: {
          StepName: CTAButtonTitle,
          StepNumber: '',
        },
        link: {
          name: CTAButtonTitle,
        },
      },
      AnalyticEvent.CTAClick,
    );
  }

  return (
    <Div
      customStyles={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: isDesktop ? '250px' : '110px',
      }}
    >
      <Div maxWidth={666}>
        <Div
          customStyles={{
            paddingInline: isDesktop ? '0' : '32px',
          }}
        >
          <Image
            src={assetUrl + image}
            width={'100%'}
            height={'auto'}
            alt="Range Img3"
            key={'range-3'}
          />
        </Div>
      </Div>
      <Div margin={isDesktop ? '80px 0 0' : '40px 0 0'}>
        <DescriptionPage
          subTitle={hero_sub_title}
          title={hero_title_line_1}
          titleStrong={hero_title_line_2}
          descriptions={body.replace(
            JSONMARKDOWN.model,
            VWCARMODELLABELS[model].replace('&', 'and'),
          )}
          CTAButtonTitle={CTAButtonTitle}
          handleCTA={() => onClickHandleCTA(model, CTAButtonTitle)}
        />
      </Div>
    </Div>
  );
}
